<div class="select-partner">
  <app-custom-dropdown *ngIf="model.accounts" [display]="'name'" [items]="model.accounts" [user]="user"
    [selectedItem]="model.accountSelected" (settings)="settings($event)" (change)="changeAccount($event)">
  </app-custom-dropdown>
</div>